<script>
    import {poiStore} from '@js/stores/poiStore';

    import I18n from '@js/modules/translations';

    import Icon from '@js/components/themes/Icon.svelte';
    import {RIDE_TYPE_ICON} from '@js/components/themes/icons';

    const _handleShowOnMapClick = (planPoiId, event) => {
        event.preventDefault();

        poiStore.map.centerPlanPoiMarker(planPoiId, true);
    };
</script>

{#if $poiStore.planPois.length}
    <h2 class="title-h2 mt-10">
        {I18n.t('js.ride.plan.index.list.title')}
    </h2>

    <div>
        {#each $poiStore.planPois as planPoi (planPoi.id)}
            <div class="mt-4 p-3 flex items-center justify-between border-t rounded-xl block-shadow hover:bg-primary-100">
                <div class="flex items-center">
                    <div class="p-1 text-primary-800 border border-1 border-primary-600 rounded-full">
                        <Icon class="h-5 w-5"
                              icon={RIDE_TYPE_ICON[planPoi.rideType]}/>
                    </div>

                    <div class="ml-2 flex flex-col">
                        <div class="text-base text-gray-900 font-bold leading-snug">
                            {planPoi.title}
                        </div>

                        {#if planPoi.description}
                            <div class="leading-snug text-xs text-gray-600">
                                {planPoi.description}
                            </div>
                        {/if}

                        {#if planPoi.associatedRides.length}
                            <div class="my-2 text-sm">
                                {#each planPoi.associatedRides as associatedRide (associatedRide.id)}
                                    <a class="inline-flex items-center me-2 px-4 py-1.5 text-gray-800 text-xs font-medium bg-gray-100 dark:bg-gray-700 border border-gray-500 rounded"
                                       href={associatedRide.link}>
                                        <svg class="w-2.5 h-2.5 me-1.5" aria-hidden="true"
                                             xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                            <path d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0Zm3.982 13.982a1 1 0 0 1-1.414 0l-3.274-3.274A1.012 1.012 0 0 1 9 10V6a1 1 0 0 1 2 0v3.586l2.982 2.982a1 1 0 0 1 0 1.414Z"/>
                                        </svg>

                                        <span class="underline">
                                            {associatedRide.name}
                                        </span>

                                        <span class="text-gray-900">
                                            : {[associatedRide.formattedDistance, associatedRide.formattedDuration, associatedRide.levelTranslated].compact()
                                            .join(' - ')}
                                        </span>
                                    </a>
                                {/each}
                            </div>
                        {/if}
                    </div>
                </div>

                <button type="button"
                        class="button-primary-outlined"
                        onclick={_handleShowOnMapClick.bind(this, planPoi.id)}>
                    {I18n.t('js.ride.plan.index.list.show_on_map')}
                </button>
            </div>
        {/each}
    </div>
{/if}
